var render, staticRenderFns
import script from "./DevOps.vue?vue&type=script&lang=js&"
export * from "./DevOps.vue?vue&type=script&lang=js&"
import style0 from "./DevOps.vue?vue&type=style&index=0&id=efb44c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb44c1a",
  null
  
)

/* custom blocks */
import block0 from "./DevOps.vue?vue&type=custom&index=0&blockType=h2&class=font-weight-bold"
if (typeof block0 === 'function') block0(component)
import block1 from "./DevOps.vue?vue&type=custom&index=1&blockType=button&class=btn-outline-kovatek%20text-uppercase%20mt-2"
if (typeof block1 === 'function') block1(component)
import block2 from "./DevOps.vue?vue&type=custom&index=2&blockType=div&class=top-devs%20m-auto"
if (typeof block2 === 'function') block2(component)
import block3 from "./DevOps.vue?vue&type=custom&index=3&blockType=HowItWorks"
if (typeof block3 === 'function') block3(component)
import block4 from "./DevOps.vue?vue&type=custom&index=4&blockType=Footer"
if (typeof block4 === 'function') block4(component)

export default component.exports